// Convert base64 VAPID public key to Uint8Array (required by pushManager.subscribe)
const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
};

export const subscribeToPush = async (token) => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.log('[Push] Not supported in this browser — serviceWorker or PushManager missing');
    return;
  }

  const permission = Notification.permission;
  console.log(`[Push] Notification permission: ${permission}`);
  if (permission === 'denied') {
    console.log('[Push] Permission denied by user — push will not work');
    return;
  }

  try {
    // Fetch VAPID public key from server
    console.log('[Push] Fetching VAPID public key...');
    const keyRes = await fetch('/api/push/vapid-public-key');
    const { publicKey } = await keyRes.json();
    console.log(`[Push] VAPID key received — present: ${!!publicKey}`);

    // Wait for service worker to be ready
    console.log('[Push] Waiting for service worker...');
    const registration = await navigator.serviceWorker.ready;
    console.log('[Push] Service worker ready');

    // Subscribe to push
    console.log('[Push] Subscribing to push manager...');
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    });
    console.log('[Push] Subscribed successfully — saving to server...');

    // Save subscription to backend
    const saveRes = await fetch('/api/push/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ subscription })
    });
    console.log(`[Push] Subscription saved — server responded: ${saveRes.status}`);
  } catch (err) {
    console.error('[Push] Subscription failed:', err.message);
  }
};
